<template>
  <div>
    <Tabs type="card" v-model="current">
      <TabPane label="预定信息" name="bookinfo">
        <keep-alive>
          <book-info :bookInfo="bookInfo" :bookInfoHistory="bookInfoHistory" :isChangeStock="isChangeStock"></book-info>
        </keep-alive>
      </TabPane>
      <TabPane label="账单信息" name="billinfo">
        <keep-alive>
          <BillInfo :receiptBillList="receiptBillList" :paymentBills="paymentBills" :receiptBillTips="receiptBillTips" :bookInfo="bookInfo"></BillInfo>
        </keep-alive>
      </TabPane>
      <div slot="extra">
        <a href="javascript:void(0);" v-if="bookInfo && bookInfo.fid" @click.stop="showResverText(bookInfo.fid)"> 查看预定协议</a>
      </div>
    </Tabs>
  </div>
</template>

<script>
  import BookInfo from './components/BookInfo'
  import BillInfo from './components/BillInfo'
  import {getReservationDetail ,getReservationBills, getReservationText} from "../../../../../api/book";

  export default {
    name: "index",
    created(){
      this.fid = this.$route.query.fid
      console.log("this.fid:", this.fid)
      this.initData()
    },
    components:{
      BookInfo,
      BillInfo
    },
    data(){
      return {
        current:'bookinfo',
        fid:'',
        bookInfo: null,
        bookInfoHistory:[],
        isChangeStock:0,
        receiptBillList:[],
        paymentBills:[],
        receiptBillTips:''
      }
    },
    methods:{
      initData(){
        getReservationDetail({fid: this.fid}).then( res => {
          this.bookInfo = res.data.reservationOrderVo;
          this.bookInfoHistory = res.data.reservationOrderLogVos;
          this.isChangeStock = res.data.isChangeStock;

          getReservationBills({fid: this.fid}).then( res => {
            this.receiptBillList = res.data.receiptBillList;
            this.receiptBillTips = res.data.receiptBillTips;
            this.paymentBills = res.data.paymentBills;

          }).catch(error=>{

          })
        })

      },
      showResverText(bookFid){
        getReservationText({reservationId: bookFid}).then( res => {
          if(!res.data){
            this.$Message.info('电子签章正在下载，请稍后刷新页面或返回重试')
            return
          }
          window.open(res.data.signPdfUrlForHttps,'_blank')
        }).catch(error=>{

        })
      }
    }
  }
</script>

<style scoped>

</style>
